import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import SvgCalendar from 'src/components/Svgs/SvgCalendar'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { css } from 'styled-components'

interface DateTextInputFieldProps {
  value: string
  onChange?: (v: string) => void
  onBlur?: (v: string) => void
  onClick?: () => void
  focus?: boolean
  label?: React.ReactElement
  placeholder: string
  disabled?: boolean
  tooltipText?: React.ReactElement
}

const DateTextInputField: React.FC<DateTextInputFieldProps> = (
  props,
): React.ReactElement => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        width: 140px;
      `}
    >
      <span
        css={css`
          ${getFontCss(
            12,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )}
          margin-bottom: 4px;
          display: inline-flex;
          align-items: center;
        `}
      >
        {props.label}
        {props.tooltipText && (
          <Tooltip
            css={css`
              height: 16px;
            `}
            openLeft={false}
          >
            {props.tooltipText}
          </Tooltip>
        )}
      </span>
      <div
        onClick={props.onClick}
        onKeyPress={props.onClick}
        role="button"
        tabIndex={0}
        css={css`
          display: flex;
          height: 40px;
          background-color: ${styleConstants.colors.gray_lightest};
          border: 1px solid ${styleConstants.colors.gray_medium};
          border-radius: 6px;

          ${props.focus &&
          css`
            border: 1px solid ${themeConstants.colors.cta};
          `}

          ${!props.disabled &&
          css`
            &:focus-within,
            &:hover {
              background-color: ${styleConstants.colors.white};
              border: 1px solid ${themeConstants.colors.cta};
            }
          `}
          ${props.disabled &&
          css`
            opacity: 0.5;
            pointer-events: none;
          `}
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            padding: 10px 0px 10px 10px;
            margin: 0px;
            cursor: pointer;
            background-color: ${styleConstants.colors.gray_lightest};
            border-radius: 6px;
          `}
        >
          <SvgCalendar />
        </div>
        <div
          css={css`
            display: inline-box;
            box-sizing: border-box;
            margin-left: 6px;
            margin-top: 2px;
          `}
        >
          <input
            placeholder={props.placeholder}
            type={'text'}
            value={props.value}
            onChange={(e): void => {
              props.onChange && props.onChange(e.target.value)
            }}
            onBlur={(e): void => {
              props.onBlur && props.onBlur(e.target.value)
            }}
            disabled={props.disabled}
            css={css`
              height: 100%;
              width: 100%;
              box-sizing: border-box;
              border: none;
              background-color: transparent;
              ${getFontCss(
                14,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )}

              &::placeholder {
                opacity: 0.5;
                ${getFontCss(
                  14,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.regular,
                )}
                @include font-14-darkest-regular;
              }
            `}
          />
        </div>
      </div>
    </div>
  )
}

export default DateTextInputField
